$(document).ready(function () {
    $('#experienceForm').validate({
        rules: {
            title: {
                required: true,
                minlength: 5,
                maxlength: 255,
            },
            content: {
                required: true,
                minlength: 5,
            },
        },
        messages: {
            title: {
                required: 'Please give your experience a title',
                minlength: 'Your experience must be a minimum of 5 characters',
            },
            content: {
                required: 'Please give a description of your experience',
                minlength: 'Your experience must be a minimum of 5 characters',
            },
        },
        submitHandler: function (form) {
            form.submit();
        },
    });
});
